<template>
  <div class="column">
    <woot-modal-header
      :header-title="$t('CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.FILTERS.TITLE')"
    >
      <p>
        {{ $t('CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.FILTERS.SUB_TITLE') }}
      </p>
    </woot-modal-header>
    <div class="row modal-content">
      <div class="small-12 medium-12 columns filters-wrap">
        <!-- :filter-groups="filterGroups"
            :grouped-filters="true" -->
        <filter-input-box
          v-for="(filter, i) in appliedFilters"
          :key="i"
          v-model="appliedFilters[i]"
          :filter-attributes="filterAttributes"
          :input-type="getInputType(appliedFilters[i].attribute_key)"
          :operators="getOperators(appliedFilters[i].attribute_key)"
          :dropdown-values="getDropdownValues(appliedFilters[i].attribute_key)"
          :show-query-operator="i !== appliedFilters.length - 1"
          :show-user-input="showUserInput(appliedFilters[i].filter_operator)"
          :v="$v.appliedFilters.$each[i]"
          @resetFilter="resetFilter(i, appliedFilters[i])"
          @removeFilter="removeFilter(i)"
        />
        <div class="filter-actions">
          <woot-button
            icon="add"
            variant="smooth"
            size="small"
            @click="appendNewFilter"
          >
            {{ $t('CONTACTS_FILTER.ADD_NEW_FILTER') }}
          </woot-button>
          <!-- v-if="hasAppliedFilters" -->
          <woot-button
            icon="subtract"
            color-scheme="alert"
            variant="smooth"
            size="small"
            @click="clearFilters"
          >
            {{ $t('CONTACTS_FILTER.CLEAR_ALL_FILTERS') }}
          </woot-button>
        </div>
      </div>

      <div class="small-12 medium-12 columns">
        <div class="modal-footer justify-content-end w-full">
          <woot-button class="button clear" @click.prevent="onClose">
            {{ $t('CONTACTS_FILTER.CANCEL_BUTTON_LABEL') }}
          </woot-button>
          <woot-button @click="submitFilterQuery">
            {{ $t('CONTACTS_FILTER.SUBMIT_BUTTON_LABEL') }}
          </woot-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import alertMixin from 'shared/mixins/alertMixin';
import { required, requiredIf } from 'vuelidate/lib/validators';
import FilterInputBox from 'components/widgets/FilterInput/Index.vue';

import {
  AI_AGENT_CALL_REPORT_STATUS,
  CALL_TWILIO_DIRECTIONS,
  CALL_TWILIO_KINDS,
} from '../broadcastAgent/aiCampaignConstant';
import filterMixin from 'shared/mixins/filterMixin';

export default {
  components: {
    FilterInputBox,
  },
  mixins: [alertMixin, filterMixin],
  props: {
    onClose: {
      type: Function,
      default: () => {},
    },
    filterItems: {
      type: Array,
      default: () => [],
    },
    initialAppliedFilters: {
      type: Array,
      default: () => [],
    },
    filterAttributes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      show: true,
      appliedFilters: [
        {
          attribute_key: 'contact_name',
          filter_operator: 'equal_to',
          values: '',
          query_operator: 'and',
        },
      ],
      filterTypes: this.filterItems,
      filterGroups: [],
    };
  },
  validations: {
    appliedFilters: {
      required,
      $each: {
        values: {
          required: requiredIf(prop => {
            return !(
              prop.filter_operator === 'is_present' ||
              prop.filter_operator === 'is_not_present'
            );
          }),
        },
      },
    },
  },
  watch: {
    initialAppliedFilters: {
      handler(newVal) {
        if (newVal?.length) {
          this.appliedFilters = newVal.map(filter => {
            const dropdownValues = this.getDropdownValues(filter.attribute_key);
            if (
              dropdownValues &&
              filter.values &&
              (typeof filter.values === 'object' ||
                Array.isArray(filter.values))
            ) {
              const matchedValue = dropdownValues?.find(
                option =>
                  option.id === filter.values.id ||
                  option.id === filter.values[0]
              );

              if (matchedValue) {
                return {
                  ...filter,
                  values: matchedValue,
                };
              }
            }

            return { ...filter };
          });

          const lastFilterIndex = this.appliedFilters.length - 1;
          if (
            this.appliedFilters[lastFilterIndex] &&
            !this.appliedFilters[lastFilterIndex].query_operator
          ) {
            this.appliedFilters[lastFilterIndex].query_operator = 'and';
          }
        } else {
          // Reset to default filter when no filters applied
          this.appliedFilters = [
            {
              attribute_key: 'contact_name',
              filter_operator: 'contains',
              values: '',
              query_operator: 'and',
            },
          ];
        }
      },
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    submitFilterQuery() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      const formattedFilters = this.appliedFilters.map(el => {
        const temp = { ...el };
        if (
          typeof el.values === 'object' &&
          typeof el.values.id !== 'undefined'
        ) {
          temp.values = [el.values.id];
        } else if (Array.isArray(el.values)) {
          temp.values = [...el.values];
        } else {
          temp.values = el.values ? [el.values] : '';
        }

        if (
          temp.filter_operator === 'is_present' ||
          temp.filter_operator === 'is_not_present'
        ) {
          delete temp.values;
        }

        return temp;
      });

      this.$emit('applyFilter', formattedFilters);
    },
    getInputType(key) {
      const type = this.filterTypes.find(filter => filter.attributeKey === key);
      return type.inputType;
    },
    getOperators(key) {
      const type = this.filterTypes.find(filter => filter.attributeKey === key);
      return type.filterOperators;
    },
    getDropdownValues(type) {
      switch (type) {
        case 'evaluation':
          return AI_AGENT_CALL_REPORT_STATUS.map(el => ({
            ...el,
            name: this.$t(el.title),
          }));
        case 'call_direction':
          return CALL_TWILIO_DIRECTIONS.map(el => ({
            ...el,
            name: this.$t(el.title),
          }));
        case 'agent_type':
          return CALL_TWILIO_KINDS.map(el => ({
            ...el,
            name: this.$t(el.title),
          }));
        default:
          return undefined;
      }
    },
    showUserInput(operatorType) {
      if (operatorType === 'is_present' || operatorType === 'is_not_present')
        return false;
      return true;
    },
    resetFilter(index, currentFilter) {
      this.appliedFilters[index].filter_operator = this.filterTypes.find(
        filter => filter.attributeKey === currentFilter.attribute_key
      ).filterOperators[0].value;
      this.appliedFilters[index].values = '';
    },
    removeFilter(index) {
      if (this.appliedFilters.length <= 1) {
        this.showAlert(this.$t('CONTACTS_FILTER.FILTER_DELETE_ERROR'));
      } else {
        this.appliedFilters.splice(index, 1);
      }
    },
    appendNewFilter() {
      // attribute_key: name, agent_name
      this.appliedFilters.push({
        attribute_key: 'reference_id',
        filter_operator: 'equal_to',
        values: '',
        query_operator: 'and',
      });
    },
    clearFilters() {
      this.$emit('clearFilters');
      this.onClose();
    },
    // methods end
  },
};
</script>

<style></style>
